import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsDevrantComponent } from './simple-icons-devrant.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsDevrantComponent ],
    exports:      [ SimpleIconsDevrantComponent ],
    bootstrap:    []
})
export class SimpleIconsDevrantModule {}
